import axios from 'axios'
import config from '../config/dev.json'
import { refresh } from './auth.service.js'
import Vue from 'vue';

let path = '/api/v1'
let url = config.host + path + '/secure/entity'
let urlNLP = config.hostnlp

import production from '../config/production.json'
if (process.env.NODE_ENV === 'production') {
  url = production.host + path + '/secure/entity'
}
export async function getDefaultEntities(obj){
  return new Promise((resolve, reject) => {
   console.log("############# obj##########", obj)
  axios.post(urlNLP + '/nlp', obj, {
    headers: {
      'Content-type': 'application/JSON'
    }
  }).then((respse) => {
    let resp = respse.data
    resolve(resp)
  }).catch(err =>{console.log('test err \n', err); reject(err)})
})
}
export async function getEntityById(id) {
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/' + id).then((response) => {
      let entity = response.data.data
      resolve(entity)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(getEntityById())
        }).catch(err => reject(err))
      }
    })
  })
}

export async function getAllEntities() {
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/all').then((response) => {
      let entities = response.data.data
      resolve(entities)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(getAllEntities())
        }).catch(err => reject(err))
      }
    })
  })
}
export async function getAllEntity() {
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/all').then((response) => {
      let entities = response.data.data
      resolve(entities)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(getAllEntity())
        }).catch(err => reject(err))
      }
    })
  })
}

export async function getAllEntitiesByBot(id) {
  return new Promise((resolve, reject) => {
 
    axios.get(url + '/get/all/' + id ).then((response) => {
   let entities = response.data.data
      resolve(entities)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(getAllEntitiesByBot(id))
        }).catch(err => reject(err))
      }
    })
  })
}

export async function getAllSynonyms(idBot) {
  
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/'+ idBot+'/all/synonyms').then((response) => {
      let synonyms = response.data.data
     console.log("######### response data ##", synonyms)
      resolve(synonyms)
    }).catch(err => {
      if(err.response.status == 401){
        resfesh().then(() => {
          resolve(synonyms)
        }).catcht(err => reject(err))
      }
    })
  })
}
export async function addEntity(entity) {
  return new Promise((resolve, reject) => {

    entity.slug = entity.name.toLowerCase()
    console.log("########## servie add entity", entity)
    axios.post(url + '/add', entity).then((response) => {
      let entityNew = response.data.data
    
      resolve(entityNew)
    }).catch(err => reject(err))
  })
}

export async function addSynonyms(children) {
  console.log('My beautiful children <3',children);
  return new Promise((resolve, reject) => {
  
    axios.post(url + '/synonyms/add', children).then((response) => {
      let entity = response.data.data[0]
      resolve(entity)
    }).catch(err => reject(err))
  })
}

export async function addContent(children) {
  return new Promise((resolve, reject) => {
  console.log("############ debut service #########",children)
    axios.post(url + '/content/add', children).then((response) => {
      console.log('##########response.data.data',response.data.data)
      if(response.data.data=="This value exist"){
        let propsData = {
          direction: "right",
          duration: 1500
        }
        Vue.prototype.$notif.show(
          (propsData = {
            title: "Error !",
            message: "Please check your list maybe this value exist",
            type: "danger"
          })
        );
      }else{
        let entity = response.data.data
      resolve(entity)
      }
      
    }).catch(err => reject(err))
  })
}

export async function deleteContent(child){
  return new Promise((resolve, reject) => {
    axios.post(url + '/content/remove', child).then((response) => {
      let child  = response.data.data
      resolve(child)
    }).catch(err => reject(err))
  })
}

export async function deleteEntity(entities){
  return new Promise((resolve, reject) => {
    if (entities._id) {
      axios.delete(url + '/remove/' + id).then((response) => {
        resolve(response.data.data)
      }).catch(err => reject(err))
    } else {
      console.log(entities)
      entities.forEach(el => {
        axios.delete(url + '/remove/' + el._id).then((response) => {
          resolve(response.data.data)
        }).catch(err => reject(err))
      })
    }
  })

}

export async function updateEntity(entity){
  return new Promise((resolve, reject) => {
    axios.put(url + '/update/'+entity._id, entity).then((response) => {
      let upEntity = response.data.data
      console.log('############ upEntity service ', upEntity)
      resolve(upEntity)
    }).catch(err => reject(err))
  })
}

export async function updateContent(child){
  return new Promise((resolve, reject) => {
  
    axios.post(url + '/content/update', child).then((response) => {
      let child = response.data.data
     
      resolve(child)
    }).catch(err => reject(err))
  })
}


// WEBPACK FOOTER //
// ./src/api/entities.service.js